<div class="page-body">
    <div class="row"> 
    <!-- Cards de Resumo -->
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" blockClass="text-center">
        <h2 class="mb-2">{{resumoCards.totalClientes}}</h2>
        <h6 class="text-muted">Total de Clientes</h6>
        <div class="progress mt-2" style="height: 5px">
          <div class="progress-bar bg-primary" role="progressbar" style="width: 75%"></div>
        </div>
      </app-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" blockClass="text-center">
        <h2 class="mb-2">{{resumoCards.auditoriasAndamento}}</h2>
        <h6 class="text-muted">Auditorias em Andamento</h6>
        <div class="progress mt-2" style="height: 5px">
          <div class="progress-bar bg-success" role="progressbar" style="width: 65%"></div>
        </div>
      </app-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" blockClass="text-center">
        <h2 class="mb-2">{{resumoCards.auditoriasConcluidas}}</h2>
        <h6 class="text-muted">Auditorias Concluídas</h6>
        <div class="progress mt-2" style="height: 5px">
          <div class="progress-bar bg-warning" role="progressbar" style="width: 45%"></div>
        </div>
      </app-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <app-card [hidHeader]="true" blockClass="text-center">
        <h2 class="mb-2">{{resumoCards.novasSolicitacoes}}</h2>
        <h6 class="text-muted">Novas Solicitações</h6>
        <div class="progress mt-2" style="height: 5px">
          <div class="progress-bar bg-danger" role="progressbar" style="width: 25%"></div>
        </div>
      </app-card>
    </div>

    <!-- Gráfico Principal -->
    <div class="col-xl-8 col-md-12">
      <app-card [title]="'Desempenho das Auditorias'">
        <div class="row align-items-center">
          <div class="col-9">
            <h3 class="mb-4">Resumo Mensal</h3>
          </div>
          <div class="col-3">
            <select class="form-control" [(ngModel)]="mesSelecionado" (change)="onMesChange($event.target.value)">
              <option *ngFor="let mes of meses" [value]="mes">{{mes}}</option>
            </select>
          </div>
        </div>
        <div class="chart-container" style="position: relative; height:300px;">
          <div class="d-flex justify-content-between mb-4">
            <div>
              <h6 class="text-muted">Total de Auditorias</h6>
              <h4>{{desempenhoAuditorias.total}}</h4>
            </div>
            <div>
              <h6 class="text-muted">Em Andamento</h6>
              <h4>{{desempenhoAuditorias.andamento}}</h4>
            </div>
            <div>
              <h6 class="text-muted">Concluídas</h6>
              <h4>{{desempenhoAuditorias.concluidas}}</h4>
            </div>
          </div>
          <div class="progress mb-4" style="height: 20px">
            <div class="progress-bar bg-success" role="progressbar" [style.width.%]="desempenhoAuditorias.percentuais.sucesso">
              {{desempenhoAuditorias.percentuais.sucesso}}%
            </div>
            <div class="progress-bar bg-warning" role="progressbar" [style.width.%]="desempenhoAuditorias.percentuais.andamento">
              {{desempenhoAuditorias.percentuais.andamento}}%
            </div>
            <div class="progress-bar bg-danger" role="progressbar" [style.width.%]="desempenhoAuditorias.percentuais.pendente">
              {{desempenhoAuditorias.percentuais.pendente}}%
            </div>
          </div>
        </div>
      </app-card>
    </div>

    <!-- Cards Laterais -->
    <div class="col-xl-4 col-md-12">
      <div class="row">
        <div class="col-12">
          <app-card [title]="'Status das Auditorias'" [options]="false">
            <div class="row align-items-center mb-3" *ngFor="let status of statusAuditorias">
              <div class="col-8">
                <h6 class="text-muted mb-0">{{status.status}}</h6>
                <h4 class="mb-0">{{status.quantidade}}</h4>
              </div>
              <div class="col-4 text-right">
                <span class="badge badge-{{status.tipo}}">{{status.variacao}}</span>
              </div>
            </div>
          </app-card>
        </div>
        <div class="col-12">
          <app-card [title]="'Últimas Atividades'" [options]="false">
            <ul class="list-unstyled">
              <li class="mb-3" *ngFor="let atividade of ultimasAtividades">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <h6 class="mb-0">{{atividade.titulo}}</h6>
                    <small class="text-muted">{{atividade.cliente}}</small>
                  </div>
                  <span class="badge badge-{{atividade.tipo}}">{{atividade.status}}</span>
                </div>
              </li>
            </ul>
          </app-card>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <!-- Gráfico de Pizza -->
    <div class="col-xl-6 col-md-12">
      <app-card [title]="'Distribuição de Auditorias por Status'">
        <div class="row">
          <div class="col-md-6">
            <div class="pie-chart-container">
              <div class="pie-chart" [ngStyle]="{'background': 'conic-gradient(#28a745 0deg ' + pieChartData.graus.concluidas + 'deg, #ffc107 ' + pieChartData.graus.concluidas + 'deg ' + (pieChartData.graus.concluidas + pieChartData.graus.andamento) + 'deg, #dc3545 ' + (pieChartData.graus.concluidas + pieChartData.graus.andamento) + 'deg 360deg)'}">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pie-chart-legend">
              <div class="legend-item">
                <div class="legend-color bg-success"></div>
                <div class="legend-text">
                  <span>Concluídas</span>
                  <strong>{{pieChartData.concluidas}}%</strong>
                </div>
              </div>
              <div class="legend-item">
                <div class="legend-color bg-warning"></div>
                <div class="legend-text">
                  <span>Em Andamento</span>
                  <strong>{{pieChartData.andamento}}%</strong>
                </div>
              </div>
              <div class="legend-item">
                <div class="legend-color bg-danger"></div>
                <div class="legend-text">
                  <span>Pendentes</span>
                  <strong>{{pieChartData.pendentes}}%</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        </app-card>
      </div> 
  
    <!-- Gráfico de Barras -->
    <div class="col-xl-6 col-md-12">
      <app-card [title]="'Distribuição por Status'" [cardClass]="'card-chart'">
        <div class="bar-chart-container">
          <div class="bar-chart">
            <div class="bar-group">
              <div class="bar bg-success" [ngStyle]="{'height': (pieChartData.concluidas * 2.5) + 'px'}">
                <span class="bar-value">{{pieChartData.concluidas}}%</span>
              </div>
              <div class="bar-label">Concluídas</div>
            </div>
            <div class="bar-group">
              <div class="bar bg-warning" [ngStyle]="{'height': (pieChartData.andamento * 2.5) + 'px'}">
                <span class="bar-value">{{pieChartData.andamento}}%</span>
              </div>
              <div class="bar-label">Em Andamento</div>
            </div>
            <div class="bar-group">
              <div class="bar bg-danger" [ngStyle]="{'height': (pieChartData.pendentes * 2.5) + 'px'}">
                <span class="bar-value">{{pieChartData.pendentes}}%</span>
              </div>
              <div class="bar-label">Pendentes</div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
    </div>
  </div>